import AssetUploadFile from '../../../components/upload-file/AssetUploadFile';

const AddAssetPage = () => {
  return <AssetUploadFile />;
};

export default AddAssetPage;
